import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent } from 'mbs-ui-kit';

@UntilDestroy()
@Component({
  selector: 'mbs-something-went-wrong',
  templateUrl: './something-went-wrong.component.html',
  styleUrls: ['./something-went-wrong.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ButtonComponent, I18NextPipe],
  standalone: true
})
export class SomethingWentWrongComponent {
  @Output() refresh = new EventEmitter<void>();
}
